import mergeToNew from "@insite/client-framework/Common/mergeToNew";
import Zone from "@insite/client-framework/Components/Zone";
import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import WidgetProps from "@insite/client-framework/Types/WidgetProps";
import GridContainer, { GridContainerProps } from "@insite/mobius/GridContainer";
import GridItem, { GridItemProps } from "@insite/mobius/GridItem";
import { mediaOptions } from "@insite/mobius/utilities/breakpointMediaQueries";
import getColor from "@insite/mobius/utilities/getColor";
import { COLORS } from "@store/theme/common/design";
import breakpointValuesMediaQueries from "@store/utilities/breakpointValuesMediaQueries";
import React, { FC } from "react";
import { connect } from "react-redux";
import { css } from "styled-components";

interface OwnProps extends WidgetProps {
    extendedStyles?: CategoryDetailsWrapperStyles;
}

export interface CategoryDetailsWrapperStyles {
    container?: GridContainerProps;
    categoryListContainer?: GridItemProps;
    categoryTilesContainer?: GridItemProps;
}

export const categoryDetailsWrapperStyles: CategoryDetailsWrapperStyles = {
    container: {
        gap: 0,
        css: css`
            border-top: 1px solid ${getColor("common.border")};
            ${({ theme }) =>
                breakpointValuesMediaQueries(
                    theme,
                    [{ values: ["26px", "30px", "48px", null, null], properties: ["padding-top"] }],
                    mediaOptions.min,
                )}
        `,
    },
    categoryListContainer: {
        width: [12, 12, 3, 3, 2],
        css: css`
            ${({ theme }) =>
                breakpointValuesMediaQueries(
                    theme,
                    [
                        {
                            values: [`1px solid ${COLORS.border.base}`, null, "0", null, null],
                            properties: ["border-bottom"],
                        },
                        {
                            values: ["0", null, `1px solid ${COLORS.border.base}`, null, null],
                            properties: ["border-right"],
                        },
                        {
                            values: ["10px 15px 25px", null, "10px 20px 0 0", null, "10px 40px 0 0"],
                            properties: ["padding"],
                        },
                    ],
                    mediaOptions.min,
                )}
        `,
    },
    categoryTilesContainer: {
        width: [12, 12, 9, 9, 10],
        css: css`
            ${({ theme }) =>
                breakpointValuesMediaQueries(
                    theme,
                    [
                        {
                            values: ["30px 0 0 0", null, "10px 0 0 30px", "10px 0 0 100px", null],
                            properties: ["padding"],
                        },
                    ],
                    mediaOptions.min,
                )}
        `,
    },
};

const CategoryDetailsWrapper = ({ id, extendedStyles }: OwnProps) => {
    const [styles] = React.useState(() => mergeToNew(categoryDetailsWrapperStyles, extendedStyles));
    return (
        <GridContainer {...styles.container}>
            <GridItem {...styles.categoryListContainer}>
                <Zone zoneName="ListContainer" contentId={id} />
            </GridItem>
            <GridItem {...styles.categoryTilesContainer}>
                <Zone zoneName="TilesContainer" contentId={id} />
            </GridItem>
        </GridContainer>
    );
};

const storeCategoryDetailsWrapper: WidgetModule = {
    component: CategoryDetailsWrapper,
    definition: {
        displayName: "Category Details Wrapper",
        group: "Categories",
    },
};

export default storeCategoryDetailsWrapper;
